import { Alert, Avatar, Typography, Link, Stack } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleAlert, ArrowBackBlue } from 'Images';

export const PaychecksAlert = () => {
  const tofes106Href =
    'https://www.kolzchut.org.il/he/%D7%98%D7%95%D7%A4%D7%A1_106';

  const isDesktop = useIsDesktop();
  const dictionary = useDictionary(Dictionary, DICTIONARY.Paychecks);

  return (
    <Stack
      direction={'row'}
      gap={'8px'}
      bgcolor={'primary.shade_100'}
      padding={isDesktop ? '24px 16px' : '12px'}
      borderRadius={'12px'}
      border={isDesktop ? '1px solid' : undefined}
      borderColor='primary.shade_200'
      maxWidth={isDesktop ? undefined : '327px'}
    >
      <Avatar
        alt={''}
        src={PurpleAlert}
        sx={{
          width: '24px',
          height: '24px',
        }}
      />
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap={isDesktop ? '0' : '4px'}
      >
        <Typography
          variant='body3'
          color={'text.secondary'}
          marginRight={'5px'}
        >
          {dictionary.subtitle.lineTwo}
        </Typography>
        <Link
          href={tofes106Href}
          display={'flex'}
          flexDirection={'row'}
          alignItems={'center'}
          underline='hover'
          target='_blank'
        >
          <Typography variant='body2'>
            {dictionary.subtitle.linkText}
          </Typography>
          <Avatar
            alt={''}
            src={ArrowBackBlue}
            sx={{ width: '16px', height: '16px', margin: 0 }}
          />
        </Link>
      </Stack>
    </Stack>
  );
};
